export var ErrorCode;
(function (ErrorCode) {
    ErrorCode["LOGIN_ATTEMPTS_EXCEEDED"] = "USX1001";
    ErrorCode["EXPIRED_PASSWORD"] = "USX1002";
    ErrorCode["UNDERAGE_DEPENDENT_FORBIDDEN"] = "AUT1002";
    ErrorCode["COGNITO_ACCOUNT_UNCONFIRMED"] = "ECX1002";
})(ErrorCode || (ErrorCode = {}));
